/* src/app/candidate-form/candidate-form.component.scss */
.candidateOffer {
  background-image: linear-gradient(rgba(245, 242, 236, 0.94), rgba(245, 242, 236, 0.94)), url("./media/candidate-bg.jpg");
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
}
.cf-page {
  padding-bottom: 24px;
}
.job-date-expired {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.55;
  filter: grayscale(0.15);
}
.job-date-expired .cf-submit-btn {
  cursor: not-allowed;
}
.link-expired-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 1.5rem;
  box-sizing: border-box;
}
.link-expired-card {
  max-width: 420px;
  width: 100%;
  background: #fff;
  border: 1px solid #e2ded5;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(18, 37, 57, 0.1);
  padding: 2.5rem 2rem;
  text-align: center;
}
.link-expired-icon {
  margin-bottom: 1.25rem;
}
.link-expired-icon mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #c09935;
}
.link-expired-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.75rem;
}
.link-expired-message {
  font-size: 1.05rem;
  color: #444;
  margin: 0 0 0.5rem;
  line-height: 1.5;
}
.link-expired-sub {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}
.icon-box {
  background: #fdf7e9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 10px;
  color: #c09935;
  border: 1px solid rgba(192, 153, 53, 0.2);
}
.icon-box mat-icon {
  font-size: 23px;
  width: 23px;
  height: 23px;
}
.candidateOffer .candidate_Details {
  width: 70%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 100%;
  border: 0;
  border-radius: 12px;
}
.candidate_Details2,
.cf-header-card,
.cf-form-card,
.cf-questions-card {
  box-shadow: 0 1px 2px rgba(18, 37, 57, 0.06), 0 10px 30px -18px rgba(18, 37, 57, 0.14);
  border: 1px solid #e2ded5;
  border-radius: 12px;
  background: #fff;
}
.sub-text {
  display: block;
  margin-top: 0;
  color: rgba(19, 23, 32, 0.8);
  font-size: 17px;
  margin-bottom: 0;
  padding: 3px 11px;
  font-weight: 500;
}
.candidate_Details h2 {
  padding: 3px 10px;
  margin-bottom: 0;
  font-size: 24px;
  font-weight: 600;
  color: #111827;
}
.cf-section-title {
  margin-left: 15px;
  margin-bottom: 16px;
  margin-top: 8px;
  font-weight: 600;
  font-size: 1.05rem;
  color: #96731c;
  border-left: 3px solid #c09935;
  padding-left: 10px;
}
.candidateOffer .mat-mdc-card-header {
  display: flex;
  padding: 25px 25px 0;
}
.cf-header-inner {
  gap: 14px;
}
.midHeading {
  color: #6a7181;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
}
.midHeading mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #c09935;
  margin-right: 4px;
}
.downloadButton,
.cf-download-btn {
  border: 1px solid #c09935;
  color: #96731c !important;
  background: #fdf7e9 !important;
  font-weight: 500;
  font-size: 13px;
  border-radius: 8px;
  padding: 12px 16px;
  letter-spacing: 0.3px;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.downloadButton:hover:not(:disabled),
.cf-download-btn:hover:not(:disabled) {
  background: #f8edd4 !important;
  border-color: #96731c;
}
.downloadButton mat-icon,
.cf-download-btn mat-icon {
  color: #c09935 !important;
}
.candidate_Details .mdc-card__actions {
  display: flex;
  justify-content: flex-start !important;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.card-actions-wrap {
  flex-wrap: wrap;
}
.form-card {
  margin-top: 10px;
  margin-bottom: 25px;
  padding: 15px 10px;
}
.answereArea {
  background-color: #ffffff;
  padding: 20px 27px;
  border-radius: 12px;
}
.table,
.cf-questions-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2ded5;
  border-radius: 8px;
  overflow: hidden;
}
th,
td {
  padding: 12px;
  text-align: left;
}
.cf-questions-table thead th {
  background-color: #fdf7e9;
  font-weight: 600;
  color: #111827;
  border-bottom: 1px solid #e2ded5;
}
.cf-questions-table tbody tr:nth-child(even) {
  background: rgba(245, 242, 236, 0.35);
}
.cf-file-input,
.file-input-resp {
  padding: 9px;
  border: 1px solid #e2ded5;
  border-radius: 8px;
  font-size: 13px;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.cf-file-input:focus,
.file-input-resp:focus {
  outline: none;
  border-color: #c09935;
  box-shadow: 0 0 0 3px rgba(192, 153, 53, 0.15);
}
.cf-submit-btn {
  background-color: #c0842c;
  border: none;
  color: #fff;
  margin-right: 10px;
  padding: 10px 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}
.cf-submit-btn:hover:not(:disabled) {
  background-color: #a66f22;
}
.cf-submit-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.cf-actions {
  padding-bottom: 8px !important;
}
.codeArea {
  position: relative;
}
.codeArea .addCoding {
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 999;
  width: 65px;
}
.codeArea .mat-mdc-form-field {
  margin-bottom: 0;
  padding: 0;
}
.codeArea .mat-mdc-input-element {
  padding-left: 80px;
}
.country-codes {
  width: 128%;
  max-width: 120px;
}
.country-search {
  width: 80px;
}
.responsive-table {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
::ng-deep .form-group mat-label {
  font-size: 13px;
  color: #6a7181;
  font-weight: 500;
}
:host ::ng-deep .mdc-text-field--filled {
  background: transparent !important;
}
.candidateOffer ::ng-deep .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix {
  padding-top: 15px !important;
}
.candidateOffer ::ng-deep .mat-mdc-select-trigger {
  margin-top: 1px !important;
}
.candidateOffer ::ng-deep .mat-mdc-form-field.mat-focused .mdc-notched-outline .mdc-notched-outline__leading,
.candidateOffer ::ng-deep .mat-mdc-form-field.mat-focused .mdc-notched-outline .mdc-notched-outline__notch,
.candidateOffer ::ng-deep .mat-mdc-form-field.mat-focused .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #c09935 !important;
}
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__leading,
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__notch,
.candidateOffer ::ng-deep .mat-mdc-form-field.ng-invalid.ng-touched .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #f44336 !important;
}
.question-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__leading,
.question-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__notch,
.question-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__trailing,
.custom-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__leading,
.custom-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__notch,
.custom-answer-field.field-error ::ng-deep .mat-mdc-text-field-wrapper .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #f44336 !important;
}
.file-input-resp.file-input-error,
.cf-file-input.file-input-error {
  border: 2px solid #f44336;
  border-radius: 8px;
}
@media (max-width: 576px) {
  .link-expired-card {
    padding: 1.75rem 1.25rem;
  }
  .link-expired-title {
    font-size: 1.5rem;
  }
  .link-expired-icon mat-icon {
    font-size: 52px;
    width: 52px;
    height: 52px;
  }
}
@media (max-width: 1024px) {
  .candidateOffer .candidate_Details {
    width: 90%;
  }
  .candidateOffer .mat-mdc-card-header {
    padding: 20px 15px 0;
  }
  .form-card {
    padding: 15px 12px;
  }
  .answereArea {
    padding: 16px 20px;
  }
}
@media (max-width: 768px) {
  .candidateOffer .candidate_Details {
    width: 95%;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .candidateOffer .mat-mdc-card-header {
    padding: 15px 12px 0;
    flex-direction: column;
    align-items: stretch;
  }
  .candidate_Details .mdc-card__actions {
    flex-direction: column;
    align-items: stretch;
    padding: 15px !important;
  }
  .form-card {
    padding: 12px 10px;
    margin-bottom: 24px;
  }
  .cf-section-title {
    margin-left: 10px;
    font-size: 1.1rem;
  }
  .answereArea {
    padding: 14px 12px;
  }
  .responsive-table {
    overflow-x: visible;
  }
  .questions-table thead {
    display: none;
  }
  .questions-table tbody tr.question-row {
    display: block;
    border: 1px solid #e2ded5;
    border-radius: 10px;
    margin-bottom: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(18, 37, 57, 0.08);
    background: #fff;
  }
  .questions-table td {
    display: block;
    text-align: left;
    padding: 10px;
    border: none !important;
    border-bottom: 1px solid #f3f4f6 !important;
  }
  .questions-table tr.question-row td:first-child {
    padding-top: 0;
  }
  .questions-table tr.question-row td:last-child {
    border-bottom: none !important;
    padding-bottom: 0;
  }
  .questions-table td::before {
    content: attr(data-label);
    font-weight: 600;
    font-size: 12px;
    color: #96731c;
    display: block;
    margin-bottom: 10px;
  }
  .questions-table td.answer-cell::before {
    margin-bottom: 12px;
  }
  .questions-table .mat-mdc-form-field {
    width: 100%;
    margin-top: 4px;
  }
  .questions-table .custom-answer-field {
    width: 100%;
    margin-top: 12px;
  }
  .codeArea .addCoding {
    width: 75px;
  }
  .codeArea .addCoding .country-codes {
    max-width: 100px;
  }
  .codeArea .mat-mdc-input-element {
    padding-left: 68px;
  }
  .downloadButton,
  .cf-download-btn {
    width: 100%;
  }
  .table,
  .cf-questions-table {
    border: 0 !important;
  }
  .candidate_Details h2 {
    font-size: 18px;
  }
  .icon-box {
    padding: 7px;
  }
  .sub-text {
    font-size: 14px;
    margin-bottom: 0;
    padding: 0 11px;
  }
  .midHeading {
    font-size: 14px;
  }
}
@media (max-width: 576px) {
  .candidateOffer .candidate_Details {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;
  }
  .form-card {
    padding: 10px 8px;
  }
  .cf-section-title {
    margin-left: 8px;
    font-size: 1rem;
  }
  .answereArea {
    padding: 12px 10px;
  }
  .questions-table tbody tr.question-row {
    padding: 18px;
    margin-bottom: 14px;
  }
  .common_button_sub button,
  .cf-submit-btn {
    width: 100%;
    margin-right: 0;
  }
}
/*# sourceMappingURL=candidate-form.component.css.map */
